import sendMsg from './http'

class outSide {
    pushCarInfo(data) {
        return sendMsg.post({
            url: '/outSide/pushCarInfo',
            data: data
        })
    }

    getPlaceSellRule(data) {
        return sendMsg.post({
            url: '/outSide/getPlaceSellRule',
            data: data
        })
    }
}

export default new outSide;